import 'angularTable';
import TableFilter from 'edge/platform/widgets/table/TableFilter';

export default angular.module('edge.platform.widgets.table', ['angular-table']).component('gwTableFilter', TableFilter);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/table/module.js
// module id = 103
// module chunks = 0